export enum notifications {
  allow_transcription_for_voicemail = 'notifications.allow_transcription_for_voicemail',
  comment_notifications_email = 'notifications.comment_notifications_email',
  missed_call_notifications_email = 'notifications.missed_call_notifications_email',
  analytics_notifications = 'notifications.analytics_notifications',
  notifications_preferences = 'notifications.notifications_preferences',
  task_notifications_email = 'notifications.task_notifications_email',
  voicemail_notifications_email = 'notifications.voicemail_notifications_email',
  online_schedule_notifications = 'notifications.online_schedule_notifications',
}